import { DiagramNode } from "@/app/features/diagrams/components/shared/DiagramNode";

// Owns the gate outcomes and feedback loop beneath the validation decision.
export function DeterministicControlsOutcomes() {
  return (
    <>
      <path
        d="M 312 475 L 200 475 L 200 523"
        fill="none"
        stroke="var(--ga-brass, #9c6b3e)"
        strokeWidth="1.8"
        markerEnd="url(#dc-arrow-neutral)"
      />
      <text
        x="256"
        y="466"
        textAnchor="middle"
        fill="var(--ga-brass, #9c6b3e)"
        className="text-[11px] font-mono font-bold"
      >
        valid
      </text>
      <path
        d="M 388 475 L 500 475 L 500 523"
        fill="none"
        stroke="#e11d48"
        strokeWidth="1.5"
        strokeDasharray="5 4"
        opacity="0.85"
        markerEnd="url(#dc-arrow-fallback)"
      />
      <text
        x="444"
        y="466"
        textAnchor="middle"
        fill="#e11d48"
        className="text-[11px] font-mono font-bold"
      >
        invalid / failure
      </text>
      <DiagramNode
        x={80}
        y={525}
        width={240}
        height={50}
        label="Next State / Execute"
        sublabel="State Update & Audit Log"
        variant="brass"
      />
      <DiagramNode
        x={380}
        y={525}
        width={240}
        height={50}
        label="Quarantine / Triage"
        sublabel="Human Alert / Fallback"
        variant="fallback"
      />
      <path
        d="M 80 550 L 45 550 L 45 171 L 218 171"
        fill="none"
        stroke="var(--ga-brass, #9c6b3e)"
        strokeWidth="1.5"
        strokeDasharray="3 4"
        opacity="0.35"
        markerEnd="url(#dc-arrow-neutral)"
      />
    </>
  );
}
